"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartValidationService = void 0;
var CartValidationService_1 = require("./implementation/CartValidationService");
exports.cartValidationService = new CartValidationService_1.CartValidationService();
//# sourceMappingURL=index.js.map